// Type del riepilogo "Ritiri di oggi" servito da
// ``GET /api/orders/pickup-summary``. Replica del legacy
// ``_aggiorna_riepilogo_ritiri``: aggregato per carrier degli ordini
// Itamoby/Ityhome con mail "merce pronta" arrivata oggi.

export interface RitiriSdaSummary {
  carrier: "SDA";
  colli: number;
  volume_m3: number;
  peso_kg: number;
  max_l: number;
  max_p: number;
  max_a: number;
  orders: number;
}

export interface RitiriBrtSummary {
  carrier: "BRT";
  colli_pacchi: number;
  colli_bancali: number;
  volume_m3: number;
  peso_kg: number;
  orders_pacchi: number;
  orders_bancali: number;
}

export interface RitiriOtherSummary {
  carrier: "OTHER";
  colli: number;
  volume_m3: number;
  peso_kg: number;
  orders: number;
}

export interface RitiriOggi {
  date: string; // ISO yyyy-mm-dd
  date_display: string; // "dd/mm"
  sda: RitiriSdaSummary;
  brt: RitiriBrtSummary;
  other: RitiriOtherSummary;
}

// Mock per modalita design (?mock=1). Riproduce lo screenshot legacy:
// SDA 46 colli + max dims, BRT 10 colli (split pacchi/bancali).
export const mockRitiri: RitiriOggi = {
  date: "2026-04-27",
  date_display: "27/04",
  sda: {
    carrier: "SDA",
    colli: 46,
    volume_m3: 1.665,
    peso_kg: 449.2,
    max_l: 218,
    max_p: 124,
    max_a: 21,
    orders: 18,
  },
  brt: {
    carrier: "BRT",
    colli_pacchi: 4,
    colli_bancali: 6,
    volume_m3: 2.591,
    peso_kg: 281.0,
    orders_pacchi: 2,
    orders_bancali: 3,
  },
  other: {
    carrier: "OTHER",
    colli: 0,
    volume_m3: 0,
    peso_kg: 0,
    orders: 0,
  },
};
